;(function ($, window, document, undefined) {

  // Create the defaults once
  var pluginName = 'beStudent',
    defaults = {
      propertyName: "value"
    };

  // The actual plugin constructor
  function Plugin(element, options) {
    this.element = element;

    this.options = $.extend({}, defaults, options);

    this._defaults = defaults;
    this._name = pluginName;

    this.init();
  }

  Plugin.prototype.init = function () {
    Plugin = this;
    var hasCvLoaded = false;
    var currentLocationPath = window.location.href;

    $('.js--generatePass').on('click', function () {
      Plugin.getPass($(this).attr('data-id'));
    });
    $('#copyPass').on('click', function () {
      $('#temporary').select();
      document.execCommand("copy");
      Plugin.setTooltip('Copiado', this);
      Plugin.hideTool(this);

    });

    $('.js--generateRecoveryLink').on('click', function () {
      Plugin.getRecoveryLink($(this).attr('data-id'));
    });
    $('#copyRecovery').on('click', function () {
      $('#temporaryLink').select();
      document.execCommand("copy");
      Plugin.setTooltip('Copiado', this);
      Plugin.hideTool(this);

    });

    $('.js-load-student-cv').on('click', function () {
      if (!hasCvLoaded) {
        Plugin.loadStudentCV();
        hasCvLoaded = true;
      }
    });

    if (!hasCvLoaded && currentLocationPath.slice(currentLocationPath.length - 2) === '#3') {
      Plugin.loadStudentCV();
      hasCvLoaded = true;
    }

  };


  Plugin.prototype.setTooltip = function (message, currentElement) {
    var id = '#' + currentElement.id;

    $(id).tooltip('enable')
      .attr('data-original-title', message)
      .tooltip('show');
  };

  Plugin.prototype.hideTool = function (currentElement) {
    var id = '#' + currentElement.id;

    setTimeout(function () {
      $(id).tooltip('disable');
    }, 1000);
  };

  Plugin.prototype.getPass = function ($id) {

    var Plugin = this;

    $.ajax({
      url: window.location.origin + '/alumnos/temporary-password/' + $id,
      success: function (data) {
        var obj = JSON.parse(data);
        console.log(obj);
        Plugin.printPass(obj.real_password);
        Plugin.showMessage(obj.expires_at);
      },
      error: function (data) {
        console.info(data);
      }
    });
  };

  Plugin.prototype.getRecoveryLink = function ($id) {
    var Plugin = this;

    $.ajax({
      url: window.location.origin + '/alumnos/recovery-link/' + $id,
      success: function (data) {
        Plugin.printRecoveryLink(data)
      },
      error: function (data) {
        console.info(data);
      }
    });
  }
  Plugin.prototype.printPass = function (data) {
    $('.cointainerButtonCopy').removeClass('hide');
    $('.cointainerGeneratePass').addClass('hide');
    $('#temporary').focus();
    $('#temporary').val(data);
  };

  Plugin.prototype.printRecoveryLink = function (data) {
    $('.containerButtonCopyRecovery').removeClass('hide');
    $('.containerGenerateRecoveryLink').addClass('hide');
    $('#temporaryLink').focus();
    $('#temporaryLink').val(data);
  }
  Plugin.prototype.showMessage = function (data) {
    $('#PassMessage').removeClass('hide');
    $('#PassMessage > span').text(data);
  };

  Plugin.prototype.loadStudentCV = function () {
    var Plugin = this;
    var loadCv = $('.js-load-student-cv-view');
    var id = loadCv.attr('data-studentId');

    Plugin.toggleLoading(true);
    loadCv.load(window.location.origin + '/alumnos/edit/' + id + '/cv', function () {
      Plugin.toggleLoading(false);
    });
  }

  Plugin.prototype.toggleLoading = function (isLoading) {
    if (isLoading) {
      $('.student-cv-loading').toggleClass('hide');
    }
    else {
      $('.student-cv-loading').toggleClass('hide');
    }
  };

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName,
          new Plugin(this, options));
      }
    });
  }

})(jQuery, window, document);